import { utmUtils } from "@/utils/utm";
import { useEffect } from "react";

/**
 * Hook to capture and manage UTM parameters
 */
export const useUTM = () => {
	useEffect(() => {
		// Only run on client side
		if (typeof window === "undefined") return;

		// Extract UTM parameters from current URL
		const urlParams = utmUtils.extractFromURL();

		// If UTM parameters exist in URL, save them
		if (Object.keys(urlParams).length > 0) {
			utmUtils.save(urlParams);
		}

		// Clean up expired UTM parameters
		utmUtils.load(); // This will automatically clean up expired params
	}, []);

	return {
		getCurrent: utmUtils.getCurrent,
		hasValidParams: utmUtils.hasValidParams,
		clear: utmUtils.clear,
	};
};
